import { useContext } from 'react';
import type { FieldValues } from 'react-hook-form';
import type { DataManagementContextType } from '../interfaces/DataManagementContextType';
import { DataManagementContext } from '../types/DataManagementContext';

/**
 * @group Hooks
 * @summary Use data management context
 * 
 * <blockquote>
 * Hook to access the data management context
 * </blockquote>
 * 
 * @returns {DataManagementContextType<TData>} The data management context
 */
export function useDataManagementContext<TData extends FieldValues>() {
  const context = useContext(DataManagementContext);
  if (!context) throw new Error('useDataManagementContext must be used within DataManagementProvider');
  return context as DataManagementContextType<TData>;
} 